export interface ScoreTriggerEditable {
  operator: '<' | '>' | 'between';
  from: string;
  to: string;
}

export const emptyScoreTrigger = (): ScoreTriggerEditable => ({
  operator: '<',
  from: '0',
  to: '100',
});
